<!--  -->
<template>
	<div>
        <div v-if="orderDetail.type == 0">
    		<div class="fail">{{$t('OrderDetail.order2')}}</div>
            <van-button @click="$router.push('/OrderDetail/'+sessionStorage.actOrderId)" class="btn" block>{{$t('OrderDetail.returnOrder')}}</van-button>
        </div>
        <div v-if="orderDetail.type == 2">
            <div class="fail">{{$t('OrderDetail.order2')}}</div>
            <van-button @click="continueOrder()" class="btn" block>{{$t('OrderDetail.newOrder')}}</van-button>
            <van-button @click="goOrder()" class="btn" block>{{$t('OrderDetail.checkOrder')}}</van-button>
        </div>
        <van-loading size="50" type="spinner" v-show="isLoading"/>
	</div>
</template>

<script>
export default {
	data () {
        return {
            orderDetail:{},
            transactionId: '',
            orderId: '',
            orderLineType: '',
            isLoading: true,
        };
    },
    mounted(){
        this.transactionId = this.$route.query.transactionId;
    	this.orderId = this.$route.query.orderId;
        this.getOrderDetail();
    },
    methods: {
        goOrder(){
            this.$toast({
                type:'fail',
                message:this.$t('OrderDetail.noPayOrder'),
            });
            var self = this;
            if(sessionStorage.storeId){
                setTimeout(()=>{
                    self.continueOrder();
                },500)
            }
            // if(localStorage.onlyCode){
            //     if(localStorage.onlyCode==localStorage.successCode && localStorage.takeOrderId!==undefined){
            //         this.getOrderDetail();
            //     }else{
            //         this.$toast({
            //             type:'fail',
            //             message:this.$t('OrderDetail.noPayOrder'),
            //         });
            //         var self = this;
            //         setTimeout(()=>{
            //             self.continueOrder();
            //         },500)
            //     }
            // }else{
            //     this.$toast({
            //         type:'fail',
            //         message:this.$t('OrderDetail.noPayOrder'),
            //     });
            //     var self = this;
            //     setTimeout(()=>{
            //         self.continueOrder();
            //     },500)
            // }
        },
        // 获取订单详情
        getOrderDetail(){
            this.$axios({
                method: 'POST',
                url: this.$build+'/api/order/search',
                data:{
                    order:this.orderId
                }
            }).then(res => {
                if(res.data.status==200){
                    console.log(res)
                    this.orderDetail=res.data.data;
                    sessionStorage.setItem('code',this.orderDetail.code);
                    localStorage.setItem('successCode',this.orderDetail.code);
                    localStorage.setItem('takeOrderId',this.orderDetail.id);
                    sessionStorage.setItem('actOrderId',this.orderDetail.id);
                    localStorage.setItem('takeOrderNo',this.orderDetail.order);
                    if(this.orderDetail.place){
                        sessionStorage.setItem('storeId',this.orderDetail.place.store_id);
                        sessionStorage.setItem('placeId',this.orderDetail.place.id);
                        sessionStorage.setItem('type','');
                    }
                    if(this.orderDetail.order_address){
                        sessionStorage.setItem('storeId',this.orderDetail.order_address.store_id);
                    }

                    if(this.orderDetail.status < 2){
                        var vm = this;
                        // 跳转到订单页面
                        setTimeout(()=>{
                            localStorage.setItem('isPay',true);
                            vm.$router.push('/TakeCartDetail');
                        },500)
                    }else{
                        localStorage.setItem('isPay',false);
                        this.$router.push('/TakeOrderDetail/'+localStorage.takeOrderId);
                    }
                }else{
                    for (var item in res.data.error) {
                        this.$toast({
                            type:'fail',
                            message:res.data.error[item],
                        });
                    }
                }
                this.isLoading = false;
            }).catch(err => {
                this.$toast({
                    type:'fail',
                    message:this.$t('common.message'),
                });
            });
        },
    	continueOrder(){
    		this.$axios({
                method:'get',
                url:this.$build+'/api/shopcart/create',
            }).then(res=>{
                console.log(res)
                this.isLoading = false;
                if(res.data.status==200){
                    localStorage.setItem('onlyCode',res.data.code)
                    var vm = this;
                    // 跳转到菜品页面
                    setTimeout(()=>{
                        vm.$router.push('/TakeDishes')
                    },500)
                }else{
                    for (var item in res.data.error) {
                        this.$toast({
                            type:'fail',
                            message:res.data.error[item],
                        });
                    }
                }
            }).catch(err => {
                this.$toast({
                    type:'fail',
                    message:this.$t('common.message'),
                });
            });
    	},
    }
}

</script>
<style scoped>
    .home{
        width: 100%;
        height: 100vh;
        background-color: #fff;position: relative;
    }
    .fail{
		height: 200px;
		text-align: center;
		line-height: 200px;
		font-size: 30px;
		color: #84D48D;
		font-weight: bold;
		background: #fff;
	}
	.btn{
		background: #2f75f4;
		color: #fff;
		margin:10px auto;
		width: 50%;
		border-radius: 10px;
	}
    /deep/ .van-loading {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        -webkit-transform: translate(-50%,-50%);
    }
</style>


// WEBPACK FOOTER //
// src/takeAway/PayFail.vue